import { useTranslation } from 'react-i18next';
import RadixSelect from '../../../shared/RadixSelect/RadixSelect.jsx';

const selectStyles = {
  control: provided => ({
    ...provided,
    borderRadius: '8px',
    borderColor: '#DBDDE0',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    minHeight: '44px',
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '10px 16px',
  }),
  placeholder: provided => ({
    ...provided,
    color: '#CACCCF',
    fontWeight: 500,
  }),
  option: provided => ({
    ...provided,
    fontSize: '14px',
    fontWeight: 500,
    color: '#25282B',
  }),
  menuPortal: provided => ({
    ...provided,
    zIndex: 9999,
    fontSize: '14px',
    fontWeight: 500,
  }),
};

export const CategorySelect = ({ categories = [], value, onChange }) => {
  const { t } = useTranslation('vault');

  const currentValue =
    categories.find(cat => String(cat.value) === String(value)) || null;

  const handleChange = option => {
    onChange(option?.value ?? null);
  };

  return (
    <RadixSelect
      options={categories}
      value={currentValue}
      onChange={handleChange}
      placeholder={t('selectCategory')}
      styles={selectStyles}
      components={{ IndicatorSeparator: () => null }}
      menuPortalTarget={document.body}
      menuPosition="fixed"
    />
  );
};
